/**
 * Safe logging utility that only logs in development mode
 * Use this for logging sensitive user data like voice transcripts
 */

const isDev = import.meta.env.DEV;

export const devLog = {
  /**
   * Log general information (only in development)
   */
  log: (...args: any[]) => {
    if (isDev) {
      console.log(...args);
    }
  },

  /**
   * Log warnings (only in development)
   */
  warn: (...args: any[]) => {
    if (isDev) {
      console.warn(...args);
    }
  },

  /**
   * Log errors (only in development)
   */
  error: (...args: any[]) => {
    if (isDev) {
      console.error(...args);
    }
  },

  /**
   * Log sensitive user data like voice transcripts (only in development)
   */
  sensitive: (...args: any[]) => {
    if (isDev) {
      console.log('[SENSITIVE]', ...args);
    }
  }
};
